if ($('.packages-table').length > 0) {
	const pTable = $('.packages-table .table');
	const pTableBody = $('.packages-table #dynamicTableBody');
	const pSearchInput = $('.packages-table .search-input');
	const resetButton = $('.packages-table .p-reset');
	const searchButton = $('.packages-table .p-search');
	const noResultsText = $('.packages-table .p-no-results');
	const pTilesWrapper = $('#package-tiles-view');
	const pListWrapper = $('#package-list-view');
	const viewOptions = $('.packages-table .view-options');
	const viewList = $('.packages-table .view-options #view-list-btn');
	const viewTiles = $('.packages-table .view-options #view-tiles-btn');

	let currentView = 'list';

	viewList.on('click', function () {
		$(this).addClass('active');
		viewTiles.removeClass('active');
		pTilesWrapper.hide();
		pListWrapper.show();
		currentView = 'list';
	})

	viewTiles.on('click', function () {
		$(this).addClass('active');
		viewList.removeClass('active');
		pListWrapper.hide();
		pTilesWrapper.show();
		currentView = 'grid';

		// reset any expanded descriptions
		$('.toggle-description').removeClass('displayed');
	})

	resetButton.on('click', function (e) {
		e.preventDefault();
		pSearchInput.val('');
		getPackagesData({});
		currentView = 'list';
	})

	searchButton.on('click', function (e) {
		e.preventDefault();
		pSearchInput.val(normalizeInput(pSearchInput.val(), false));
		if (pSearchInput.val() !== '') {
			getPackagesData({'q': normalizeInput(pSearchInput.val(), true)});
		}
	})

	pSearchInput.on('keyup', function (e) {
		if (e.which === 13 && pSearchInput.val() !== '') {
			searchButton.click();
		}
	})

	pSearchInput.on('blur', function (e) {
		pSearchInput.val(normalizeInput(pSearchInput.val(), false));
	})

	const formatResponse = (data, fallback) => {
		return data ? data : fallback
	}

	const getPackagesData = function (attrs) {
		pTableBody.empty();
		pTilesWrapper.empty();

		$.ajax({
			url: `${window.location.origin + ctxPath}/.rest/packages/v1/packages`,
			method: 'GET',
			dataType: 'json',
			data: attrs,
			headers: {
				'Accept': 'application/json'
			},
			timeout: 10000
		})
			.done(function (data, textStatus, xhr) {
				if (xhr.status === 204) {
					viewOptions.hide();
					pTilesWrapper.hide();
					pListWrapper.hide();
					noResultsText.show();

					$.tablesorter.destroy(pTable, false);
				}

				if (data && 'items' in data && data.items.length > 0) {
					viewOptions.show();
					noResultsText.hide();

					if(currentView === 'tiles') {
						viewTiles.addClass('active');
						pTilesWrapper.show();
						viewList.removeClass('active');
						pListWrapper.hide();
					}

					if(currentView === 'list') {
						viewTiles.removeClass('active');
						pTilesWrapper.hide();
						viewList.addClass('active');
						pListWrapper.show();
					}

					$.tablesorter.destroy(pTable, false);

					data.items.forEach(function (item) {

						const tile = `<div class="promo-card">
						<h3 class="custom-h3">${item.packageName}</h3>
						<h4 class="custom-h4">${item.packageVersion}</h4>
						<img src="${formatResponse(item.imageUrl, '-')}" alt="Package image">
						<p>${formatResponse(item.description, '-')}</p>
						<p>(${formatResponse(item.packageDimensionLength, '-')} x ${formatResponse(item.packageDimensionWidth, '-')} x ${formatResponse(item.packageDimensionHeight, '-')} (mm))</p>
						<a href="/packages/${item.packageVersion}.html" class="cta-button-details">Details</a>
						</div>`;

						pTilesWrapper.append(tile);

						const tr = `<tr>
						<td>${formatResponse(item.packageFamily, '-')}</td>
						<td>${formatResponse(item.packageName, '-')}</td>
						<td><a href="/packages/${item.packageVersion}.html">${formatResponse(item.packageVersion, '-')}</a></td>
						<td>
							<div class="package-description">
								<button class="toggle-description"></button>
								<div class="description-full">${formatResponse(item.description, '-')}</div>
							</div>
						</td>
						<td data-int>${formatResponse(item.packageDimensionLength, '-')}</td>
						<td data-int>${formatResponse(item.packageDimensionWidth, '-')}</td>
						<td data-int>${formatResponse(item.packageDimensionHeight, '-')}</td>
						<td class="nowrap">${formatResponse(item.issueDate, '-')}</td>
						<td><a href="${item.outlineDrawingUrl}"><span class="lnr lnr-download2"></span> Download</a></td>
						</tr>`;
						pTableBody.append(tr);

					})
					$('.packages-table table.tablesorter').tablesorter({
						headers: {
							3: { sorter: false },
							8: { sorter: false }
						}
					});

					$('.toggle-description').on('click', function () {
						if($(this).hasClass('displayed')) {
							$(this).removeClass('displayed');
						}
						else {
							$(this).addClass('displayed');
						}
					})
				}
			})
			.fail(function (xhr, textStatus, errorThrown) {
				console.error('ERROR', xhr.status, xhr.responseText || errorThrown);
			});
	};

	$('[data-toggle="tooltip"]').tooltip({container: 'body', html: false, trigger: 'hover'});

	const attrs = [{name: 'q', value: ''}];
	getPackagesData(attrs);
}
